(function($) {
    $(document).ready(function() {
        // Override behavior when ewform toggle is-placeholder
        $('#form-event').on('change.states blur.states input.states', 'input[type="text"]', function() {
            const $field = $(this).closest('.m-field');

            if ($(this).attr('placeholder') && $(this).val() === '') {
                $field.addClass('is-placeholder');
            } else {
                $field.removeClass('is-placeholder');
            }
        });

        $('#form-event input[type="text"]').each(function() {
            const $field = $(this).closest('.m-field');
            if ($(this).attr('placeholder') && $(this).val() === '') {
                $field.addClass('is-placeholder');
            } else {
                $field.removeClass('is-placeholder');
            }
        });
    });
})(jQuery);
